var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.baseColor),attrs:{"id":"app"}},[(_vm.showBaseLayout)?_c('layout-component'):(_vm.hasToken && _vm.newUser)?_c('novo-usuario-layout'):_c('public-layout-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }